import * as React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import PhoenixEnrollButton from 'bundles/certificate-enroll/components/PhoenixEnrollButton';
import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/ondemand';

class ContentRequiresEnrollModal extends React.Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static childContextTypes = {
    course: PropTypes.object,
  };

  getChildContext() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'course' does not exist on type 'Readonly... Remove this comment to see the full error message
    const { course } = this.props;
    return {
      course,
    };
  }

  handleClose = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onClose' does not exist on type 'Readonl... Remove this comment to see the full error message
    this.props.onClose();
  };

  render() {
    return (
      <div className="rc-ContentRequiresEnrollModal">
        <Modal
          type="layer"
          key="ContentRequiresEnrollModal"
          modalName="Join to access course content"
          handleClose={this.handleClose}
        >
          <h1>
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'course' does not exist on type 'Readonly... Remove this comment to see the full error message */}
            <FormattedMessage message={_t('Join {courseName}.')} courseName={this.props.course.get('name')} />
          </h1>
          <p>{_t('Enroll to access this course content.')}</p>
          <PhoenixEnrollButton />
        </Modal>
      </div>
    );
  }
}

export default ContentRequiresEnrollModal;
